import { render, staticRenderFns } from "./CommitteeGroupUserLabel.vue?vue&type=template&id=f7efef10&scoped=true"
import script from "./CommitteeGroupUserLabel.vue?vue&type=script&lang=js"
export * from "./CommitteeGroupUserLabel.vue?vue&type=script&lang=js"
import style0 from "./CommitteeGroupUserLabel.vue?vue&type=style&index=0&id=f7efef10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7efef10",
  null
  
)

export default component.exports